import script from "./Jurnal.vue?vue&type=script&setup=true&lang=js"
export * from "./Jurnal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__